import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const CircleCheckmarkFillIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M12 23a11 11 0 1 0 0-22 11 11 0 0 0 0 22Zm5.2-13.3a1 1 0 0 0-1.4-1.4l-5.3 5.8-2.3-2.3a1 1 0 0 0-1.4 1.4l3 3a1 1 0 0 0 1.4 0l6-6.5Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default CircleCheckmarkFillIcon;
